import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import ButtonGroup from '@tds/core-button-group';
import Notification from '@tds/core-notification';

const ViewsToggle = ({ viewType, setViewType, formErrors }) => {
  const errorMessage = _.get(formErrors, 'viewToggleButtons.text', '');

  return (
    <>
      <ButtonGroup
        name="viewType"
        onChange={e => setViewType(e.target.value)}
        value={viewType}
        label=""
      >
        <ButtonGroup.Item value="simpleView">Simple View</ButtonGroup.Item>
        <ButtonGroup.Item value="advancedView">Advanced View</ButtonGroup.Item>
      </ButtonGroup>
      {errorMessage && (
        <Notification variant="error" copy="en">
          {errorMessage}
        </Notification>
      )}
    </>
  );
};

ViewsToggle.propTypes = {
  viewType: PropTypes.string.isRequired,
  setViewType: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({}).isRequired
};

export default ViewsToggle;
